<template>
    <span :class="badgeClass">{{ text }}</span>
</template>

<script>
export default {
    name: 'EvaluationApproved',

    props: {
        approved: {
            type: Boolean,
            default: null // Or whatever default value makes sense
        }
    },

    computed: {
        text() {
            if (this.approved === null) {
                return 'Sin intentos'
            } else if (this.approved) {
                return 'Aprobado'
            } else {
                return 'Pendiente'
            }
        },

        badgeClass() {
            if (this.approved === null) {
                return 'badge bg-secondary bg-opacity-50'
            } else if (this.approved) {
                return 'badge bg-success bg-opacity-75'
            } else {
                return 'badge bg-danger bg-opacity-50'
            }
        }
    }
}
</script>